
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.506.087c-8.52 0-15.42 6.9-15.42 15.435s6.9 15.434 15.42 15.434 15.45-6.899 15.45-15.434c0-8.536-6.914-15.435-15.45-15.435zm.016 27.783c-6.822 0-12.348-5.526-12.348-12.348C3.174 8.7 8.7 3.174 15.522 3.174c6.822 0 12.347 5.526 12.347 12.348 0 6.822-5.525 12.348-12.347 12.348zm3.18-13.892l-1.637-1.636 3.272-3.272 3.273 3.272-1.637 1.636-1.636-1.636-1.636 1.636zm-7.996-1.636l1.636 1.636 1.636-1.636-3.272-3.272-3.272 3.272 1.636 1.636 1.636-1.636zm12.703 6.267c-1.235 3.148-4.29 5.402-7.887 5.402-3.597 0-6.653-2.254-7.887-5.402h15.774z","fill":"#ABABAB"}})])
          )
        }
      }
    